import { GroupType } from "@/types";

export function getAddress(community: GroupType) {
  let streetAddress =
    community.streetAddress1 && community.streetAddress2
      ? `${community.streetAddress1 + " " + community.streetAddress2}`
      : community.streetAddress1;

  let addressString = `${streetAddress}, ${community.city}, ${community.state} ${community.zip}`;

  return addressString;
}
